/**
 * Girişten sonra gidilecek sayfa (`?sonra=`). Yalnız uygulama içi yol kabul edilir: "//", "/\" ve tam
 * adresler (başka siteye yönlendirme) reddedilir, ana ekran döner.
 */
export function safeNext(search: string | URLSearchParams): string {
  const next = (typeof search === "string" ? new URLSearchParams(search) : search).get("sonra");
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return "/";
  return next;
}
